<template>
  <el-container class="style1" id="region" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-dialog title="添加标签组" :visible.sync="dialogVisible1" width="40%">
      <span>
        <el-form v-if="isshow" :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup1"
          :model="addgroup">
          <el-form-item label="类别" prop="academic">
            <el-row>
              <el-col>
                <el-select v-model="academicvalue" placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in academicfile" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="简要说明" prop="explan">
            <el-input v-model="addgroup.explan" rows="3" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup1');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm1('addgroup1')">确 定</el-button>
        <!-- <el-button type="primary" @click="groupsave()">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-dialog title="编辑标签组" :visible.sync="dialogVisible2" width="40%">
      <span>
        <el-form :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup2" :model="addgroup">
          <el-form-item label="类别" prop="academic">
            <el-row>
              <el-col>
                <el-select v-model="academicvalue" placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in academicfile" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="简要说明" prop="explan">
            <el-input v-model="addgroup.explan" rows="3" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup2');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm2('addgroup2')">确 定</el-button>

        <!-- <el-button type="primary" @click="saveeditgroup()">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-dialog title="添加标签" :visible.sync="dialogVisible3" width="40%">
      <span>
        <el-form v-if="isshow" :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup3"
          :model="addgroup">
          <el-form-item label="标签组">
            <el-input v-model="this.righttitle" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="标签" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup3');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm3('addgroup3')">确 定</el-button>

        <!-- <el-button type="primary" @click="savetag()">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-dialog title="编辑标签" :visible.sync="dialogVisible4" width="40%">
      <span>
        <el-form :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup4" :model="addgroup">
          <el-form-item label="标签组">
            <el-input v-model="this.righttitle" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="标签" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup4');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm4('addgroup4')">确 定</el-button>
        <!-- <el-button type="primary" @click="editTag()">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-header>
      <el-row style="border-bottom: 2px dashed #dcdfe6;padding-bottom: 10px;">
        <el-col style="font-size: 20px; font-weight: bold;padding-bottom: 10px;">标签管理</el-col>
      </el-row>
      <el-row style="display:flex;padding-top: 5px;"> </el-row>
    </el-header>
    <el-container style="padding: 0;">
      <el-aside style="display:flex;flex-direction:column;background-color:white;">
        <el-col class="flex2" style="padding:10px 0">
          <div style="font-weight:bold">标签组</div>
          <el-button icon="el-icon-plus" type="primary" size="small" @click="newgroup()">添加</el-button>
          <!-- 添加标签组 -->
        </el-col>
        <div class="formstyle" :style="{ 'max-height': this.timeLineHeight + 'px' }">
          <el-row v-for="(item, index) in taggroup" :key="index" class="cellstyle"
            @click.native="clickleft(item, index)" :class="activnum === index ? 'success-text' : ''">
            <div style="display: flex;">
              <div :class="activnum === index ? 'leftdiv' : ''"></div>
              <div style="flex:1">
                <el-col class="flex2 paddingleft">
                  <div style="font-size:small;font-weight:bold">{{ item.title }}</div>
                  <div class="flex1" style="align-items: center;">
                    <el-button type="text" @click="editgroup(item)" style="font-size:small;">编辑</el-button>
                    <!-- 编辑标签组 -->
                    <div style="color:#dadada;padding: 0 3px;">|</div>
                    <!-- 删除专辑组 -->
                    <el-button type="text" @click="delategroup(item)" style="font-size:small;color: #D03328;">删除
                    </el-button>
                  </div>
                </el-col>
                <el-col class="paddingleft-b">
                  <span class="tags">{{ item.sub_title }}</span>
                </el-col>
              </div>
            </div>
          </el-row>
        </div>
      </el-aside>
      <el-main style="display:flex;flex-direction:column ;padding-left:20px">
        <el-col class="flex2" style="padding: 10px 0;">
          <div style="font-weight:bold">{{ this.righttitle }}</div>
          <div>
            <el-button :disabled="taggroup.length===0" icon="el-icon-plus" type="primary" size="small" @click="addtag()">添加</el-button>
          </div>
          <!-- 添加专辑 -->
        </el-col>
        <div class="formstyle" :style="{ 'max-height': this.timeLineHeight + 'px' }">
          <!-- newfile -->
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{ color: 'black', background: '#FAFAFA' }"
            header-cell-class-name="headerStyleMy">
            <el-table-column type="index" label="序号" width="100"> </el-table-column>
            <!-- <el-table-column prop="tag_id" label="标签代码" width="150"> </el-table-column> -->
            <el-table-column prop="text" label="标签名称"> </el-table-column>
            <!-- <el-table-column prop="address" label="状态">
              <span class="flex3">
                <div class="round1"></div>
                <div>有效</div>
              </span>
            </el-table-column> -->
            <el-table-column label="操作" width="150" class-name="el-table-lable-box">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="edittag(scope.$index, scope.row)">编辑</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="mini" style="color:#E02020" @click="handleDelete(scope.$index, scope.row)">
                  删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import { number } from "echarts/lib/export";
  import http from "../../APIService/http";
  export default {
    name: "album_manage",

    data() {
      return {
        academicfile: [
          {
            value: "LIBRARY_MATERIAL",
            label: "学术资料",
          },
          {
            value: "HCP_PORTRAIT",
            label: "医生画像",
          },
        ],
        clearValidate: 0,
        isshow: true,
        academicvalue: "",
        timeLineHeight: "",
        loading: false,
        tableData: [],
        taggroup: [],
        groupid: "",
        groupidpage: "",
        tag_id: "",
        // oldnew
        rightlibrary: "",
        righttitle: "",
        rightcatlog: "",
        activnum: 0,
        groupname: "",
        albumList: [],
        medicinal: [],
        state1: false,
        library_id: "",
        catalog_id: "",
        dialogVisible1: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        labelPosition: "right",
        addgroup: {
          name: "",
          explan: "",
          sort: "",
        },
        rules: {
          name: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          // explan: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          sort: [
            { required: true, trigger: "blur", message: "此项不能为空" },
            { type: "number", message: "排序必须为数字" },
          ],
          // academic: [{ required: true, trigger: "blur" }],
        },
      };
    },
    created() {
      this.getTagGroupList();
    },
    mounted() {
      this.timeLineHeight = document.documentElement.clientHeight - 240;
      window.onresize = () => {
        this.timeLineHeight = document.documentElement.clientHeight - 240;
      };
    },
    methods: {
      handleClose() {
        this.$refs["addgroup"].clearValidate();
      },
      newgroup() {
        this.academicvalue = this.academicfile[0].value;
        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";
        this.isshow = true;
        this.dialogVisible1 = true;
      },
      clickleft(item, index) {
        // this.academicvalue = this.academicfile[0].value;
        this.activnum = index;
        this.righttitle = item.title;
        this.groupid = item.group_id;
        this.groupidpage = item.group_id;
        this.getTagList();
      },
      groupsave(item) {
        this.saveTagGroup();
        this.dialogVisible1 = false;
      },
      editgroup(item) {
        this.academicvalue = item.category;
        this.groupid = "";
        this.groupid = item.group_id;
        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";
        this.addgroup.name = item.title;
        this.addgroup.explan = item.sub_title;
        this.addgroup.sort = item.sort;
        this.dialogVisible2 = true;
      },
      saveeditgroup() {
        this.editTagGroup();
        this.dialogVisible2 = false;
      },
      delategroup(item) {
        this.groupid = "";
        this.groupid = item.group_id;
        this.deleteTagGroup();
      },
      addtag() {
        this.academicvalue = this.academicfile[0].value;
        this.isshow = true;
        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";
        this.dialogVisible3 = true;
      },
      edittag(index, row) {
        this.academicvalue = this.academicfile[0].value;
        console.log(index, row);

        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";
        this.addgroup.name = row.text;
        this.addgroup.sort = row.sort;
        this.addgroup.explan = row.tag_id;
        this.dialogVisible4 = true;
      },
      delatealbum(item) {
        this.catalog_id = "";
        this.catalog_id = item.catalog_id;
        this.deleteAlbumGroup();
        this.catalog_id = this.rightcatlog;
        this.library_id = this.rightlibrary;
        this.getTagList();
      },
      canclefun() {
        this.isshow = false;
        this.dialogVisible1 = false;
        this.dialogVisible2 = false;
        this.dialogVisible3 = false;
        this.dialogVisible4 = false;
      },
      resetForm(addgroup1) {
        // this.$refs[addgroup1].resetFields();
      },
      handleDelete(index, row) {
        this.tag_id = row.tag_id;
        this.deleteTag();
      },
      submitForm1(addgroup1) {
        this.$refs[addgroup1].validate((valid) => {
          if (valid) {
            this.groupsave(addgroup1);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      submitForm2(addgroup2) {
        this.$refs[addgroup2].validate((valid) => {
          if (valid) {
            this.saveeditgroup(addgroup2);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      submitForm3(addgroup3) {
        this.$refs[addgroup3].validate((valid) => {
          if (valid) {
            this.savetag(addgroup3);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      submitForm4(addgroup4) {
        this.$refs[addgroup4].validate((valid) => {
          if (valid) {
            this.editTag(addgroup4);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //  编辑专辑组
      async editTagGroup() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            group_id: this.groupid,
            title: this.addgroup.name,
            sub_title: this.addgroup.explan,
            sort: this.addgroup.sort,
            category: this.academicvalue
          };
          await http.post("/echo/tags/editTagGroup", data).then((res) => {
            this.getTagGroupList();
          });
        } catch (e) { }
      },
      // 删除标签组
      async deleteTagGroup() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            group_id: this.groupid,
          };
          debugger;
          await http.post("/echo/tags/deleteTagGroup", data).then((res) => {
            this.getTagGroupList();
          });
        } catch (e) { }
      },
      async deleteTag() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            tag_id: this.tag_id,
          };
          await http.post("/echo/tags/deleteTag", data).then((res) => {
            this.getTagList();
          });
        } catch (e) { }
      },
      // 添加标签
      async savetag() {
        this.dialogVisible3 = false;
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            group_id: this.groupidpage,
            text: this.addgroup.name,
            sort: this.addgroup.sort,
            reference_id: "",
            reference_obj: "",
          };
          await http.post("/echo/tags/saveTag", data).then((res) => {
            debugger;
            this.getTagList();
          });
        } catch (e) { }
      },
      // 编辑专辑

      async editTag() {
        this.dialogVisible4 = false;
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            text: this.addgroup.name,
            sort: this.addgroup.sort,
            tag_id: this.addgroup.explan,
          };

          await http.post("/echo/tags/editTag", data).then((res) => {
            this.catalog_id = this.rightcatlog;
            this.library_id = this.rightlibrary;
            this.getTagList();
          });
        } catch (e) { }
      },
      // 左侧数据 获取标签组
      async getTagGroupList() {
        this.loading = true;
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          await http.post("/echo/tags/getTagGroupList", data).then((res) => {
            this.loading = false;
            this.taggroup =res.data;
            if (res.data && res.data.length > 0) {
              this.righttitle = this.taggroup[0].title;
              this.groupid = this.taggroup[0].group_id;
              this.groupidpage = this.taggroup[0].group_id;
              this.getTagList();
              console.log(this.taggroup);

            }
            // this.library_id = this.albumList[0].library_id;
            // this.catalog_id = this.albumList[0].catalog_id;
          });
        } catch (e) {
          this.loading = false;
        }finally{
          this.loading = false;
        }
      },
      async getTagList() {
        this.loading = true;
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            group_id: this.groupid,
          };
          await http.post("/echo/tags/getTagList", data).then((res) => {
            this.tableData = res.data;
            console.log(res.data);
            this.loading = false;
          });
        } catch (e) {
          this.loading = false;
        }finally{
          this.loading = false;
        }
      },
      async saveTagGroup() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            title: this.addgroup.name,
            sub_title: this.addgroup.explan,
            sort: this.addgroup.sort,
            user_id: this.$store.getters.getUser.user_id,
            category: this.academicvalue,
          };
          debugger;
          await http.post("/echo/tags/saveTagGroup", data).then((res) => {
            this.getTagGroupList();
          });
        } catch (e) { }
      },
    },
  };
</script>

<style>
  .round1 {
    height: 8px;
    width: 8px;
    background-color: #52c41a;
    border-radius: 50%;
    display: inline-block;
  }

  .round {
    height: 8px;
    width: 8px;
    background-color: red;
    border-radius: 50%;
    display: inline-block;
  }

  .paddingleft {
    padding-left: 14px;
    padding-top: 10px;
    padding-right: 14px;
  }

  .paddingleft-b {
    padding: 0 14px;
    padding-top: 5px;
    padding-bottom: 10px;
  }

  .tags {
    background-color: #f5f5f5;
    border-color: #e9e9eb;
    color: #909399;
    border-radius: 3px;
    font-size: 2px;
    padding: 2px;
  }

  .success-text {
    background: #f0faff;
    border-left-style: solid;
    border-color: #1890ff;
  }

  .leftdiv {
    width: 2px;
    background-color: #1890ff;
  }

  .tittle1 {
    font-size: 25px;
    font-weight: bold;
  }

  .flex1 {
    display: flex;
  }

  .flex2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex3 {
    display: flex;
    align-items: center;
  }

  .header {
    border-bottom: 1px dashed #e7eaec;
  }

  .formstyle {
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    border-color: #dadada;
    flex: 1;
    overflow: overlay;
    height: 200px;
  }

  .cellstyle {
    border-bottom: 1px solid #ccc !important;
    border-color: #dadada !important;
  }

  #region {
    background: white;
    border: 1px solid #dadada;
    border-left: none;
    padding: 20px 20px;
    height: 100%;
  }

  /*  */
  #region .el-table .cell {
    padding-left: 30px;
  }

  #region .redact .el-col {
    user-select: none;
    padding-top: 14px;
    height: 100%;
    border-left: 1px solid #dcdfe6;
  }

  #region .treeBox {
    border: 1px solid #dcdfe6;
    height: 600px;
    border-top: none;
  }

  #region .el-divider--vertical {
    background: rgb(218, 218, 218) !important;
    width: 2px !important;
    margin: -1px 8px px 0;
  }

  #region .el-scrollbar {
    height: 95%;
  }

  #region .el-aside {
    background-color: white;
  }

  #region .el-container {
    padding: 0;
  }

  #region .el-scrollbar__view {
    height: 100%;
  }

  #region .el-tree .filter-tree .el-tree--highlight-current {
    height: 100%;
  }

  #region .el-tree-node .is-expanded .is-current .is-focusable {
    height: 100%;
  }

  #region .el-tree-node__content {
    height: 40px;
  }

  #region .el-tree-node:focus>.el-tree-node__content {
    background-color: #d8f6ee !important;
  }

  #region .el-dialog__close {
    display: none;
  }

  #region .el-form-item__label {
    font-size: 16px;
    color: black;
    text-align: right;
  }

  #region .el-dialog__header {
    border-bottom: 2px dashed #dcdfe6;
    padding: 20px 0 20px 0;
    margin: 20px 20px 10px;
  }

  #region .el-dialog__title {
    font-weight: bold;
    padding-top: 10px;
    padding-left: 10px;
  }

  #region .el-dialog__body {
    padding-right: 100px;
    padding-top: 20px;
  }

  #region .regionUser .el-dialog__body {
    padding-right: 20px;
    padding-top: 20px;
  }

  #region .el-main {
    padding: 0 10px;
  }

  #region .el-table th>.cell {
    font-weight: bold;
  }

  #region .el-select-dropdown__item {
    padding: 0 !important;
  }
</style>
<style scoped>
  #region>>>.region_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }

  #region>>>.region_table_cell {
    color: #2b92fa !important;
  }
</style>
<style scoped>
  #region>>>.el-table {
    margin: 0;
  }

  .headerStyleMy>div {
    font-size: 14px;
    /*color: #585757;*/
    font-weight: bold;
  }

  .divi>>>.el-divider--horizontal {
    margin: 0;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .style1>>>.el-header {
    padding: 0;
    padding-top: 10px;
    height: 100px;
  }

  .paddingleft-b>>>.el-tag--mini {
    padding: 0;
  }

  #region>>>.el-table-lable-box {
    text-align: center;
    font-weight: bold !important;
  }
</style>
<style lang="scss">
  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }
</style>


// WEBPACK FOOTER //
// src/pages/echo/Tag_manage.vue